
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disclosure",
      function () {
        return require("private-next-pages/disclosure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disclosure"])
      });
    }
  